"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * If you define no settings at all, the checkmark is used for `true` and null
 * for `false`.
 *
 * You can define custom settings for both `true` and `false`.
 *
 * settings: {
 *     true: {
 *         icon: {
 *             name: "pencil",
 *             paths: [
 *                 "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
 *             ]
 *             viewBox: "0 0 1024 1024",
 *             width: "20",
 *             height: "20",
 *         }
 *     },
 *     false: {
 *         icon: { ... }
 *     }
 * }
 *
 * You can define just one or the other. Defining just one will mean the other
 * case is null. E.g., if you have a flipped boolean, define just the `false` icon.
 *
 * settings: {
 *     false : {
 *         icon: { ... }
 *     }
 * }

 * If you have a custom `false` icon and want to use checkmark as the true
 * icon, specify `useTrueCheckmark`.
 *
 * settings: {
 *     useTrueCheckmark: true,
 *     false : {
 *         icon: { ... }
 *     }
 * }
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value;
    var trueIcon = (0, _get2["default"])(settings, 'true.icon');
    var falseIcon = (0, _get2["default"])(settings, 'false.icon');
    var useCheckmarkIfTrue = !trueIcon && !falseIcon || (0, _get2["default"])(settings, 'useTrueCheckmark');
    if (value === true || value === 1 || value === '1') {
      var _csvDownloadValue = /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].csvDownloadValue
      }, (0, _get2["default"])(settings, 'true.csvDownloadValue', null));
      if (useCheckmarkIfTrue) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])('table-renderers-boolean-icon-true', _style["default"].iconContainer)
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
          width: "20px",
          height: "20px"
        }), _csvDownloadValue);
      }
      if (!trueIcon) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "table-renderers-boolean-icon-true"
        }, _csvDownloadValue);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('table-renderers-boolean-icon-true', _style["default"].iconContainer)
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("svg", {
        width: trueIcon.width,
        height: trueIcon.height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: trueIcon.viewBox
      }, /*#__PURE__*/_react["default"].createElement("g", null, trueIcon.paths.map(function (p) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: p,
          d: p
        });
      })))), _csvDownloadValue);
    }
    var csvDownloadValue = /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].csvDownloadValue
    }, (0, _get2["default"])(settings, 'false.csvDownloadValue', null));
    if (!falseIcon) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "table-renderers-boolean-icon-false"
      }, csvDownloadValue);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-boolean-icon-false', _style["default"].iconContainer)
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("svg", {
      width: falseIcon.width,
      height: falseIcon.height,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: falseIcon.viewBox
    }, /*#__PURE__*/_react["default"].createElement("g", null, falseIcon.paths.map(function (p) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: p,
        d: p
      });
    })))), csvDownloadValue);
  };
};